import Image from "react-bootstrap/esm/Image";
import ReactMarkdown from "react-markdown";
import { useOutletContext, useParams } from "react-router-dom";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import { findMovieData } from "../utils/movie-utils";
import ImageSliderModal from "../../components/image-slider-modal";
import React from "react";
import FichaTecnica from "../../components/ficha-tecnica";
import RowContent from "../../components/containers/row-content";
import RowContentSubtitle from "../../components/containers/row-content-subtitle";
import LaboratoriosMercados from "../../components/laboratorios-mercados";
import SEO from "../../components/seo";

const DevMoviePage = () => {
    const { path } = useParams();
    const [jsonData] = useOutletContext();
    const movieData = findMovieData(jsonData.filmesEmDesenvolvimento, path);
    const [modalShow, setModalShow] = React.useState(false);
    const [initialSlide, setInitialSlide] = React.useState(0);

    const showSlide = (index) => {
        setInitialSlide(index);
        setModalShow(true);
    }

    if (!movieData) {
        return <></>;
    }

    const logoSrc = require(`./${movieData.path}/${movieData.logo}`);
    const movieTitle = movieData.nome || 'Filme';

    const anoDuracao = [movieData.ano, movieData.duracao].filter(Boolean).join(' - ');
    const anoDuracaoSpan = anoDuracao ? (
        <span className="ano-duracao-filme ps-2">({anoDuracao})</span>
    ) : null;

    const slider = (movieData.slides !== undefined &&
        <RowContent className="movie-imgs-swipper">
            <div className="col">
                <Swiper style={{ "--swiper-navigation-color": "#fff", }}
                    slidesPerView={5}
                    spaceBetween={20}
                    navigation={true}
                    pagination={{
                        clickable: true,
                    }}
                    breakpoints={{
                        200: {
                            slidesPerView: 2,
                            spaceBetween: 10
                        },
                        768: {
                            slidesPerView: 3,
                            spaceBetween: 10,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 20,
                        },
                    }}
                    modules={[Pagination, Navigation]}
                >
                    {movieData.slides.map((img, i) =>
                        <SwiperSlide key={i}>
                            <Image 
                                src={require(`./${movieData.path}/slides/${img}`)} 
                                alt={`${movieTitle} - Imagem ${i + 1}`}
                                className="img-fluid small-slide-img object-fit-cover" 
                                onClick={() => showSlide(i)}
                            />
                        </SwiperSlide>
                    )}
                </Swiper>
            </div>
        </RowContent>);

    const fichaTecnica = <FichaTecnica fichaTecnica={movieData.fichaTecnica}></FichaTecnica>
    const laboratoriosMercados = <LaboratoriosMercados laboratorios={movieData.laboratoriosMercados}></LaboratoriosMercados>

    const sinopseText = movieData.sinopse instanceof Array ? movieData.sinopse.join('') : movieData.sinopse;
    const seoTitle = movieData.ano ? `${movieData.nome} (${movieData.ano})` : movieData.nome;

    return (
        <div className="bg-white text-dark py-4 main-min-width">
            <SEO
                title={seoTitle}
                description={`${movieTitle} - ${sinopseText ? sinopseText.substring(0, 160) : 'Filme em desenvolvimento da Abdução Filmes'}`}
                path={`/em-desenvolvimento/${movieData.path}`}
            />
            <div className="container">
                <RowContent className="text-center" ><h1 className="my-0">{movieData.nome} {anoDuracaoSpan}</h1></RowContent>
                <RowContent>
                    <div className="col-md-12 col-lg-6 text-center py-2 py-lg-0">
                        {movieData.trailer ?
                            <div className="video-responsive">
                                <iframe 
                                    title={movieData.nome || 'Trailer do filme'} 
                                    src={movieData.trailer} 
                                    allowFullScreen
                                    sandbox="allow-same-origin allow-scripts allow-popups allow-presentation"
                                ></iframe>
                            </div>
                            : <Image src={logoSrc} alt={`Logo do filme ${movieTitle}`} className="img-fluid" />}

                    </div>
                    <div className="col py-2 py-lg-0">
                        <RowContentSubtitle title={"Sinopse"}/>
                        
                        <div className="text-justify">
                            <ReactMarkdown className="md-text">{movieData.sinopse instanceof Array ? movieData.sinopse.join('') : movieData.sinopse}</ReactMarkdown>
                        </div>
                    </div>
                </RowContent>
                {slider}
                {laboratoriosMercados}
                {fichaTecnica}
            </div>
            <ImageSliderModal 
                show={modalShow} 
                onHide={() => setModalShow(false)} 
                imagePathList={movieData.slides ? movieData.slides.map((img) => `/${movieData.path}/slides/${img}`) : []}
                assetsBasePath="em-desenvolvimento"
                setShow={setModalShow} 
                initialSlide={initialSlide}
                movieTitle={movieTitle}
            >
            </ImageSliderModal>
        </div>
    );
}


export default DevMoviePage;
